import { FC, useState } from 'react';
import { HiOutlinePlus } from 'react-icons/hi';
import ItinaryCard from './ItinaryCard';
import { itinaryProps } from '../../../../../../constants';
import NewItinaryForm from './NewItinaryForm';
import { Modal } from '../../../../../commons';
import { clearNewItinaryForm, scrollToElement } from '../../../../../../utils';

interface ItinaryFormProps {
  values: any;
  setFieldValue: any;
  edit?: boolean;
}

const Itinary: FC<ItinaryFormProps> = ({ values, setFieldValue, edit }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(edit ? !edit : true);
  const [showModal, setShowModal] = useState(false);

  const handleEditHandler = () => {
    if (selectedId !== null) {
      const itinary: itinaryProps = {
        day: values.day,
        title: values.itinaryTitle,
        description: values.itinaryDescription,
        meal_plan: values.meal_plan,
        accomodation: values.accommodation_plan,
      };
      const newItinaries = [...values.itineraries];
      newItinaries[selectedId] = itinary;
      setFieldValue('itineraries', newItinaries);
    }
    setIsEdit(false);
    clearNewItinaryForm(setFieldValue);
  };

  const handleAddItinary = () => {
    if (isEdit) {
      handleEditHandler();
      return;
    }
    setFieldValue('itineraries', [
      ...values.itineraries,
      {
        day: values.day,
        title: values.itinaryTitle,
        description: values.itinaryDescription,
        meal_plan: values.meal_plan,
        accomodation: values.accommodation_plan,
      },
    ]);
    clearNewItinaryForm(setFieldValue);
    if (values.itineraries.length === values.days - 1) {
      setShowForm(false);
    }
  };

  const onEditHandler = (id: number) => {
    setIsEdit(true);
    setShowForm(true);
    setSelectedId(id);
    const itinary = values.itineraries[id];
    setFieldValue('itinaryTitle', itinary.title);
    setFieldValue('itinaryDescription', itinary.description);
    setFieldValue('meal_plan', itinary.meal_plan);
    setFieldValue('accommodation_plan', itinary.accomodation);
    scrollToElement('edit');
  };

  const onDeleteHandler = (id: number) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const handleDeleteItinary = () => {
    if (selectedId) {
      const newItinaries = [...values.itineraries];
      newItinaries.splice(selectedId, 1);
      setFieldValue('itineraries', newItinaries);
      if (newItinaries.length - 1 < values.days - 1) {
        setShowForm(true);
      }
    }
    setShowModal(false);
  };

  return (
    <>
      <div className='border border-gray-200 dark:border-gray-700/50 rounded-xl p-4 my-6 bg-gray-50/50 dark:bg-gray-800/20' id='itinaries'>
        <div className='flex justify-between items-center mb-4 pb-2 border-b border-gray-200 dark:border-gray-700/50'>
          <h3 className='text-lg font-bold text-gray-900 dark:text-white'>
            Itineraries <span className='text-sm font-normal text-gray-500'>({values.itineraries.length} Days)</span>
          </h3>
          <button
            type='button'
            onClick={() => setShowForm(!showForm)}
            title='Add Itinerary'
            className='flex justify-center items-center bg-primary-600 hover:bg-primary-700 text-white rounded-lg shadow-sm w-8 h-8 transition-colors'
          >
            <HiOutlinePlus className='w-5 h-5' />
          </button>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          {values.itineraries.map((itinary: itinaryProps, idx: number) => (
            <div className='col-span-1' key={itinary.title}>
              <ItinaryCard
                {...itinary}
                onDeleteHandler={() => onDeleteHandler(idx)}
                onEditHandler={() => onEditHandler(idx)}
              />
            </div>
          ))}
        </div>
        <div id='edit'>
          {showForm && (
            <>
              <div className='flex justify-center py-5'>
                <hr className='w-4/5 text-center' />
              </div>
              <NewItinaryForm
                handleAddItinary={handleAddItinary}
                isEdit={isEdit}
                handleCancelEdit={() => {
                  setIsEdit(false);
                  clearNewItinaryForm(setFieldValue);
                }}
                values={values}
                setFieldValue={setFieldValue}
              />
            </>
          )}
        </div>
      </div>
      <Modal
        size='sm'
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setIsEdit(false);
        }}
        onSuccess={handleDeleteItinary}
        successText='Delete'
        loadingText='Saving...'
      >
        <div className='flex flex-col gap-2'>
          <h1 className='text-2xl font-semibold mb-2'>Delete Itinary</h1>
          <p className='text-tertiary mb-2'>
            Are you sure you wish to delete this Itinary? This action is permanent and can not be
            undone.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default Itinary;
